import React from 'react'

import SearchOptionItem from './SearchOptionItem'
function SearchTypeItem({ query, type, options, render }) {
    return (
        <div className={'r-search-type-item-container'}>
            <div className={'r-title'}>{type}</div>
            <div className={'r-search-type-item-options-container'}>
                {options.map((o, i) => (
                    <SearchOptionItem query={query} render={render} dataItem={o} key={i} />
                ))}
            </div>
        </div>
    )
}

export default SearchTypeItem
